export default __webpack_public_path__ + "static/media/PaintingTheLoft_03.bc990f91.png";